
import type { ConflictApiError } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { ConflictErrorModalMessages } from '../../../models/i18n/tools.messages'
import { computed, defineComponent, ref } from 'vue'
import { UiModal } from '../../keen-ui'
import { EpbButton } from '../../shared'
import ConflictErrorList from './conflict-error-list.component.vue'
import { useConflictErrors } from './use-conflict-errors'

export default defineComponent({
  name: 'ConflictErrorModal',
  components: {
    ConflictErrorList,
    EpbButton,
    UiModal,
  },
  props: {
    conflictApiError: {
      type: Object as PropType<ConflictApiError>,
      default: undefined,
    },
    messages: {
      type: Object as PropType<ConflictErrorModalMessages['dialog']>,
      required: true,
    },
    itemQueries: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    updateRouteName: {
      type: String,
      default: undefined,
    },
  },
  setup: props => {
    const uiModal = ref()

    const { conflicts } = useConflictErrors(props)

    const modalTitle = computed(() => {
      return props.conflictApiError?.title || props.messages.title
    })

    const modalContent = computed(() => {
      return props.conflictApiError?.message || props.messages.content
    })

    function open(): void {
      uiModal.value.open()
    }

    function close(): void {
      uiModal.value.close()
    }

    return {
      baseClass: 'conflict-error-modal',
      conflicts,
      modalTitle,
      modalContent,
      open,
      close,
      uiModal,
    }
  },
})
